export default __webpack_public_path__ + "static/media/arrow_right.3056bb9b.svg";